import { Vue } from 'vue-class-component';
import { TLanguageCode } from '@/includes/definitions/word.d';

const localeMap: Record<TLanguageCode, string> = {
  en: 'en-US',
  de: 'de-DE',
  fr: 'fr-FR',
};

export default class AudioMixin extends Vue {
  // eslint-disable-next-line class-methods-use-this
  pickVoice(locale: string): SpeechSynthesisVoice | undefined {
    const lang = locale.split('-')[0];
    const voices = window.speechSynthesis.getVoices()
      .filter((v) => v.lang === locale || v.lang.startsWith(lang));
    if (voices.length === 0) return undefined;

    // Prefer an exact-locale match over a same-language fallback, and a network-backed
    // voice (e.g. Chrome's "Google ..." voices) over the OS's local/offline synthesis
    // engine, which tends to sound noticeably more robotic.
    const score = (v: SpeechSynthesisVoice) => (v.lang === locale ? 2 : 0) + (v.localService ? 0 : 1);
    return voices.sort((a, b) => score(b) - score(a))[0];
  }

  speak(text: string, lang: TLanguageCode) {
    if (!this.CanSpeak) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    const locale = localeMap[lang] ?? 'en-US';
    utterance.lang = locale;
    utterance.rate = 0.9;
    const voice = this.pickVoice(locale);
    if (voice) utterance.voice = voice;
    window.speechSynthesis.speak(utterance);
  }

  // eslint-disable-next-line class-methods-use-this
  get CanSpeak() {
    return ('speechSynthesis' in window);
  }
}
